import { c as classNames, U as FontAwesomeIcon, a8 as Link, aT as LinkButton } from './className-0524835a.js';
import { B as Badge } from './Badge-fe7ff6e8.js';
import React__default from 'react';

const HeaderButton = ({ icon, title, badgeVariant, badgeCount, badgeLabel, variant = 'default', href, onClick, children }) => {
    const classes = classNames('HeaderButton', {
        'HeaderButton-mobile': variant === 'mobile'
    });
    const content = React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Badge, { variant: badgeVariant, count: badgeCount, ariaLabel: badgeLabel },
            React__default.createElement(FontAwesomeIcon, { icon: icon, size: variant === 'mobile' ? 'lg' : '2x' })),
        children);
    if (href) {
        return React__default.createElement(Link, { className: classes, title: title, ariaLabel: title, href: href, onClick: onClick }, content);
    }
    else {
        return React__default.createElement(LinkButton, { className: classes, title: title, ariaLabel: title, onClick: onClick }, content);
    }
};

export { HeaderButton as H };
